import { useTranslation } from "react-i18next";
import InitContext from "../pages/InitContext";
import { useContext, useEffect, useState } from "react";
import GraphView from "./GraphView";
import useMmcService from "../../services/MmcService";
import TabularView from "./TabularView";
import { buildNodes, buildEdges } from "./utils";
import {Consts} from "../pages/consts";
import {removeDdiDuplicates} from "../pages/utils";

const Drugs = ({ selectedPatient = null }) => {
  const { t } = useTranslation();
  const context = useContext(InitContext);
  const [patDrugs, setPatDrugs] = useState([]);
  const [drugsView, setDrugsView] = useState(Consts.TABLE);
  const [selectedDrug, setSelectedDrug] = useState({});
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);
  const {loading, error, clearError, getDbDrugs, deleteDbDrug } = useMmcService();

  useEffect(() => {
    clearError();
    receiveAndHandlePrescriptions().then();
  }, []);

  const receiveAndHandlePrescriptions = async () => {
    const patientId = !selectedPatient
      ? context?.patient?.id
      : selectedPatient?.id;

    const drugs = await getDbDrugs(context?.token, patientId, true, true);

    const drugsWithoutDuplicateDdis = drugs?.map(drug => {
      return {...drug, ddis: removeDdiDuplicates(drug?.ddis)}
    });

    if (drugsWithoutDuplicateDdis?.length > 1) {
      fillNodes(drugsWithoutDuplicateDdis);
      fillEdges(drugsWithoutDuplicateDdis);
    }

    setPatDrugs(drugsWithoutDuplicateDdis);
  };

  const deleteDrug = (drugToDelete, stopDate) => {
    clearError();

    deleteDbDrug(context?.token, drugToDelete?.id, stopDate).then(() => {
      receiveAndHandlePrescriptions().then();
    });
  };

  const fillNodes = (drugs) => {
    setNodes(() => buildNodes(drugs, t(Consts.NOT_SPECIFIED)));
  };

  const fillEdges = (drugs) => {
    setEdges(() => buildEdges(drugs, context?.role));
  };

  const handleSelected = (id) => {
    patDrugs?.forEach((drug) => {
      if (drug?.id === id) {
        setSelectedDrug(drug);
      }
    });
  };

  const handleSetDrugsView = (viewName) => {
    setSelectedDrug({});
    setDrugsView(viewName);
  };

  return (
    <>
      {drugsView === Consts.TABLE ? (
        <TabularView
          selectedPatient={selectedPatient}
          patDrugs={patDrugs}
          onDeleteDrug={deleteDrug}
          setDrugsView={handleSetDrugsView}
          errorParent={error}
          loadingParent={loading}
          onReceiveAndHandlePrescriptions={receiveAndHandlePrescriptions}
        />
      ) : (
        <GraphView
          selectedDrug={selectedDrug}
          patDrugs={patDrugs}
          setDrugsView={handleSetDrugsView}
          nodes={nodes}
          edges={edges}
          handleSelected={handleSelected}
        />
      )}
    </>
  );
};

export default Drugs;
